import "htmx.org";

import FlyingSidebarForm from "./flying_sidebar";
import LanguageSwitch from "./language_switch";
import VisitedJobsHandler from "./jobs_details";
import JobsForm from "./jobs_form";
import initSwipers from "../swiper";

const jobsFormElement = document.querySelector<HTMLFormElement | null>(
  ".jobs-form"
);
if (jobsFormElement) {
  const jobsForm = new JobsForm(jobsFormElement);
  jobsForm.init();

  const flyingForm = new FlyingSidebarForm(jobsFormElement);
  flyingForm.init();
}

const jobDetails = document.querySelector<HTMLDivElement | null>(
  "article[data-job-id]"
);
if (jobDetails) {
  const visitedJobHandler = new VisitedJobsHandler();
  visitedJobHandler.init();
}

// initialize the language switch URL watcher
const languageSwitch = new LanguageSwitch(".language-switcher-list");
languageSwitch.init();

document.body.addEventListener("pushToDataLayer", function (evt) {
  const dataBlock = evt.detail.data;
  dataBlock["deviceoutput"] = deviceOutput(window.screen.width);
  window.dataLayer.push(dataBlock);
});

document.addEventListener("htmx:load", () => {
  initSwipers();
});
